module.exports = __webpack_public_path__ + "static/media/home_heart.3e25a33d.png";